import styled from 'styled-components'

import { defaultTheme } from '@/styles/themes'

type FooterContainerProps = {
  darkMode?: boolean
}

export const FooterContainer = styled.footer<FooterContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  border-top: 1px solid
    ${({ darkMode, theme }) =>
      darkMode ? `${theme.colors.white}` : `${theme.colors.darkgray}`};
  background-color: ${({ darkMode, theme }) =>
    darkMode ? `${theme.colors.black}` : `${theme.colors.white}`};
  color: ${({ darkMode, theme }) =>
    darkMode ? `${theme.colors.white}` : `${theme.colors.darkgray}`};

  text-align: left;

  gap: 54px;

  padding: 48px 0;
  height: 669px;

  .divider {
    width: 100%;
    height: 2px;

    color: ${({ darkMode, theme }) =>
      darkMode ? `${theme.colors.white}` : `${theme.colors.darkgray}`};
  }

  .wa-icon,
  .ln-icon,
  .ig-icon,
  .fb-icon {
    transition: transform 0.3s ease-in-out;
    &:hover {
      transform: scale(1.1);
    }
  }

  .newsletter-title {
    margin-bottom: '19px';
  }

  @media (max-width: 1280px) {
    height: fit-content;
  }

  @media (max-width: 768px) {
    padding: 40px 0;
    gap: 46px;

    .newsletter-title {
      font-size: 20px;
      line-height: 30px;
    }
  }

  @media (max-width: 650px) {
    padding: 48px 25px;
  }

  @media (max-width: 570px) {
    width: 100%;
  }
`

type FormContainerProps = {
  darkMode?: boolean
}

export const FormContainer = styled.div<FormContainerProps>`
  display: flex;
  height: 419px;
  order: 0;
  justify-content: space-between;
  width: 100%;
  max-width: 1170px;

  .form-contact {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    padding: 0px;
    gap: 24px;
    width: 570px;

    form {
      width: 100%;
      display: flex;
      flex: 0 50%;
      flex-wrap: wrap;
      order: 0;
      justify-content: space-between;
    }

    .form-titles {
      display: flex;
      flex-direction: column;
      gap: 24px;
      width: 100%;
    }
  }

  .form-newsletter {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    padding: 0px;
    gap: 21px;

    width: 486px;
  }

  .send-success {
    color: ${(props) => props.theme.colors.primary};
    font-size: 1rem;
  }

  @media (max-width: 1180px) {
    flex-direction: column;
    height: fit-content;
    align-items: center;

    .form-contact {
      margin: 0;
      margin-bottom: 2.5rem;

      form {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }

      .form-titles {
        gap: 16px;
      }
    }

    .form-newsletter {
      margin: 0;
      width: 570px;
    }
  }

  @media (max-width: 570px) {
    .form-contact {
      width: 100%;

      .form-titles {
        gap: 8px;
      }
    }

    .form-newsletter {
      width: 100%;
    }
  }

  .h-input {
    display: none;
    nav-index: -1;
  }
`

type ContactContainerProps = {
  darkMode?: boolean
}

export const ContactContainer = styled.div<ContactContainerProps>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1170px;

  .contact-physical {
    display: flex;
    justify-content: space-between;
    gap: 2rem;

    div {
      width: fit-content;

      h2 {
        margin-bottom: 1rem;
      }

      p {
        margin-bottom: 1rem;
      }
    }
  }

  .contact-social {
    display: flex;
    flex-wrap: wrap;
    flex: 0;
    height: 6rem;
    justify-content: center;

    .contact-icons {
      display: flex;
      flex: 0;
      flex-direction: row;

      img {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
      }
    }
  }

  @media (max-height: 750px) {
    .contact-social {
      height: auto;
      row-gap: 0 !important;
      img {
        height: 30px;
      }
    }
  }
  @media (max-width: 1180px) {
    height: fit-content;
    align-items: flex-start;
    align-self: center;
    width: 570px;
    gap: 0;

    .contact-physical {
      flex-direction: column;
      height: fit-content;
      align-items: flex-start;

      margin-left: 0;
    }

    .contact-social {
      width: 40%;
      margin-right: 0;
      row-gap: 1rem;
    }
  }

  @media (max-width: 570px) {
    width: 100%;
    flex-direction: column;

    .contact-physical {
      width: 100%;
    }

    .contact-social {
      width: 40%;
      justify-content: flex-start;
    }
  }

  @media (max-width: 530px) {
    .contact-social {
      width: 50%;
    }
  }

  @media (max-width: 430px) {
    .contact-social {
      width: 60%;
    }
  }
`

export const Error = styled.span`
  font-size: 12px;
  color: ${defaultTheme.colors.red};
`
